export const SEARCH_SHOW = 'SEARCH_SHOW';
export const searchShow = () => ({type: SEARCH_SHOW});

export const SEARCH_HIDE = 'SEARCH_HIDE';
export const searchHide = () => ({type: SEARCH_HIDE});

export const SEARCH_UPDATE_QUERY = 'SEARCH_UPDATE_QUERY';
export const searchUpdateQuery = (query) => ({type: SEARCH_UPDATE_QUERY, query});

export const SEARCH_INITIATE = 'SEARCH_INITIATE';
export const searchInitiate = term => ({type: SEARCH_INITIATE, term});

export const SEARCH_ITEMS_FETCH = 'SEARCH_ITEMS_FETCH';
export const SEARCH_ITEMS_FETCH_SUCCESS = 'SEARCH_ITEMS_FETCH_SUCCESS';
export const SEARCH_ITEMS_FETCH_ERROR = 'SEARCH_ITEMS_FETCH_ERROR';
export const searchItemsFetch = (page = 1, query, searchQueryString) => ({type: SEARCH_ITEMS_FETCH, page, query, searchQueryString});

export const SEARCH_RESULTS_RECEIVED = 'SEARCH_RESULTS_RECEIVED';
export const searchResultsReceived = (page, result, query, searchQueryString) => ({type: SEARCH_RESULTS_RECEIVED, page, result, query, searchQueryString});

export const SEARCH_UPDATE_POSSIBLE_PAGE = 'SEARCH_UPDATE_POSSIBLE_PAGE';
export const searchUpdatePossiblePage = (possiblePage, searchQueryString) => ({type: SEARCH_UPDATE_POSSIBLE_PAGE, possiblePage, searchQueryString});

export const SEARCH_CHANGE_TAB = 'SEARCH_CHANGE_TAB';
export const searchChangeTab = tab => ({type: SEARCH_CHANGE_TAB, tab});




/** WEBPACK FOOTER **
 ** ./src/members/state/search/actions.js
 **/